import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Grid, Segment } from 'semantic-ui-react';
// import TablePaymentScheme from '../table/tablePaymentScheme';
import TablePaymentScheme from './TablePaymentScheme';
import headerTablePaymentScheme from '../constants/tableHeader';
import ButtonWithIcon from '../../../components/button/buttonWithIcon';
import HeaderTitle from '../../../components/common/headerTitle';
import Pagination from '../../../components/common/pagination';
import {
  datasetPagination,
  getNumberFromTo,
} from '../../../scripts/pagination';
import FilterData from '../../../scripts/filterDataTable';

class PaymentSchemeList extends Component {
  constructor(props) {
    super(props);
    this.currentIndex = 0;
    this.state = {
      searchInput: '',
      activePage: 1,
    };
  }
  static propTypes = {
    data: PropTypes.array,
  };
  handleChange = (e, { name, value }) =>
    this.setState({ [name]: value, activePage: 1 });
  handleChangeDate = (value, name) => {
    this.setState({ [name]: value, activePage: 1 });
  };
  pageChange = (e, { activePage }) => {
    this.setState({ activePage });
  };
  render() {
    let {
      data,
      filterBy,
      buttonNew,
      buttonEdit,
      buttonDelete,
      buttonLock,
    } = this.props;
    let { activePage, searchInput } = this.state;
    let filterData = FilterData(data, filterBy, searchInput);
    let pagedData = datasetPagination(filterData, 7);
    let listData = pagedData[activePage - 1];

    let { numbersFrom, numbersTo } = getNumberFromTo(listData, activePage, 7);
    let handleChange =
      filterBy === 'FormatedDate'
        ? this.handleChangeDate
        : this.props.filterBy === 'exchangeRate'
          ? this.handleChangeDate
          : this.handleChange;

    return (
      <div>
        <Grid columns="equal" style={{ marginTop: '30px' }}>
          <Grid.Row stretched>
            <Grid.Column width={12}>
              <Segment>
                <HeaderTitle title="Payment term scheme for company" />
                <Input
                  icon="search"
                  placeholder="search"
                  name="searchInput"
                  value={searchInput}
                  onChange={handleChange}
                />
                <ButtonWithIcon
                  text="Add New Payment Scheme"
                  iconName="add"
                  handleOnClick={buttonNew}
                  positive={true}
                  floated="right"
                />
                <TablePaymentScheme
                  data={data}
                  headerTable={headerTablePaymentScheme}
                  pageChange={this.pageChange}
                  listData={listData}
                  pagedData={pagedData}
                  buttonEdit={buttonEdit}
                  buttonDelete={buttonDelete}
                  buttonLock={buttonLock}
                />
                <Pagination
                  pagedData={pagedData}
                  numbersTo={numbersTo}
                  numbersFrom={numbersFrom}
                  data={data}
                  pageChange={this.pageChange}
                  activePage={activePage}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

PaymentSchemeList.propTypes = {
  listData: PropTypes.array,
  pagedData: PropTypes.array,
  title: PropTypes.string,
  data: PropTypes.array,
  buttonNew: PropTypes.func,
  buttonEdit: PropTypes.func,
  buttonDelete: PropTypes.func,
  buttonLock: PropTypes.func,
  filterBy: PropTypes.string,
};

export default PaymentSchemeList;
